module.exports = __webpack_public_path__ + "static/media/douche_2.ad41c87f.jpg";